import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, OnDestroy, Output, ViewChild } from '@angular/core';

import { FileUploadService, FileUploadInformation, FileUploadStatusInfo } from '../fileupload.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-file-uploader',
    templateUrl: 'uploader.component.html',
    styles: [
        `
            :host {
                display: block;
            }

            input[type='file'] {
                display: none;
            }
        `,
    ],
})
export class FileUploaderComponent implements OnChanges, OnInit, OnDestroy {
    @ViewChild('file') file: ElementRef<HTMLInputElement>;

    @Input() buttonText: string;
    @Input() color: string;
    Files: FileUploadInformation[];
    @Input() icon: string;
    @Input() url: string;
    @Input() validExtensions: string[];
    ValidExtensions: string;

    @Output() upload: EventEmitter<FileUploadInformation[]> = new EventEmitter<FileUploadInformation[]>();

    constructor(private fileSvc: FileUploadService) {
        this.Files = [];
    }

    ngOnDestroy() {}

    ngOnChanges() {
        this.ValidExtensions = this.validExtensions ? this.validExtensions.join(',') : '*';
    }

    ngOnInit() {}

    AddFiles() {
        if (this.file) {
            // Clear out the pending list of files
            this.Files = [];

            this.file.nativeElement.click();
        }
    }

    FileInputHandler() {
        const _files = this.file.nativeElement.files;

        if (_files && !!_files.length) {
            for (let i = 0, j = _files.length; i < j; ++i) {
                const _file = _files.item(i);

                this.Files.push({
                    File: _file,
                });
            }
        }

        // Return the list of files to be processed.
        this.upload.emit(this.Files);

        // Clear the file element
        this.file.nativeElement.value = '';
    }
}
